import {
  Mesh,
  CircleGeometry,
  MeshBasicMaterial,
  Vector3,
  DataTexture,
  RGBFormat,
} from 'three';
import { SceneService } from './../scene.service';
import { CircleModel } from './../../model';
import { Component, OnInit } from '@angular/core';
import { EntityComponent } from '../share/entity-component';
import { RendererService } from '../renderer.service';

@Component({
  selector: 'ng3-circle',
  templateUrl: './circle.component.html',
  styleUrls: ['./circle.component.css'],
})
export class CircleComponent extends EntityComponent<CircleModel> {
  constructor(sceneService: SceneService, renderer: RendererService) {
    super(sceneService, renderer);
  }

  createTexture() {
    const x = 50,
      y = 50;
    const textureData = new Uint8Array(3 * x * y);
    const texture = new DataTexture(textureData, x, y, RGBFormat);
    for (let i = 1; i < x; i++) {
      for (let j = 1; j < y; j++) {
        const indImg = i * y + j;
        const indTex = i + j * x;
        const stride = indTex * 3;
        // textureData[stride] = Math.random() * 256;
        // textureData[stride + 1] = Math.random() * 256;
        // textureData[stride + 2] = Math.random() * 256;
        textureData[stride] = 30;
        textureData[stride + 1] = 20;
        textureData[stride + 2] = 20;
      }
    }

    texture.needsUpdate = true;
    return texture;
  }
  createEntity(model: CircleModel) {
    const result = new Mesh(
      new CircleGeometry(model.radius, model.segments),
      new MeshBasicMaterial({ color: 0xff0000, wireframe: true }),
      // new MeshBasicMaterial({ side: DoubleSide, map: this.createTexture() }),
      // new MeshBasicMaterial({ side: DoubleSide, color: new Color(0.5, 0.5, 0.5) }),
    );
    result.name = 'circle';
    result.position.copy(model.center);
    // result.rotation.x = - Math.PI / 2;
    return result;
  }
  updateEntity(model: CircleModel, entity: Mesh) {
    entity.position.copy(model.center);
    entity.geometry = new CircleGeometry(model.radius, model.segments);
    // (entity.geometry as CircleGeometry).parameters.radius = model.radius;
    // (entity.geometry as CircleGeometry).verticesNeedUpdate = true;
    return entity;
  }
  defaultModel() {
    return new CircleModel(new Vector3(0, 0, 0), 30);
  }
}
